export default "__VITE_ASSET__DLPFn5bl__"